import { z } from "zod";

import { language } from "@rootreeweb/ns-helper";
import { createCustomSettings } from "@rootreeweb/zod-to-elements";

import type { FormDefinition } from "../types.js";
import { consentTextEN } from "./shared.js";

const schema = z.object({
	"First Name": z.string(),
	"Last Name": z.string(),
	Email: z.string().email(),
	Company: z.string(),
	Language: language,
	"Phone Number": z.string(),
	"Product Type": z.string().optional(),
	"Dieline Size": z.string().optional(),
	"Anything else we should know?": z
		.string()
		.optional()
		.describe(
			createCustomSettings({
				textArea: true,
			}),
		),
	consentTextEN,
});

const dielineRequestEN: FormDefinition<typeof schema.shape> = {
	signature: "3b5adf2552a9ab6f46d17f02699ec47c67840e9736d6bc5cc34d2be4d13b7db5",
	formID: "dieline-request-en",
	schema,
	submissionOptions: {
		subject: (formState) =>
			`Customer Dieline Information Form: ${formState["First Name"]}`,
		preamble: "Submitted information",
		postamble:
			"Contact the Web Team if you have any issues with this the data in this email.",
		recipients: ["sales@rootree.ca", "web@rootree.ca"],
	},
	formOptions: {
		strings: {
			submitButton: "Send it in!",
			success:
				"Success! A member of our team will be in touch shortly. If you need anything else, feel free to call us at 1-833-ROOTREE (766-8733).",
		},
	},
};
export default dielineRequestEN;
